export default __webpack_public_path__ + "static/media/switch.2417598d.svg";